import { useEffect } from 'react';

const SEO = ({ title, description, keywords, ogImage, ogType = 'website' }) => {
  useEffect(() => {
    // Update document title
    document.title = title ? `${title} | IdeaPetal Games` : 'IdeaPetal Games - Play Free Online Mini Games';

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Basic meta tags
    if (description) {
      updateMetaTag('description', description);
      updateMetaTag('og:description', description, true);
    }

    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    // Open Graph tags
    updateMetaTag('og:title', title || 'IdeaPetal Games', true);
    updateMetaTag('og:type', ogType, true);
    if (ogImage) {
      updateMetaTag('og:image', ogImage, true);
    }
    updateMetaTag('og:url', window.location.href, true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title || 'IdeaPetal Games');
    if (description) {
      updateMetaTag('twitter:description', description);
    }
    if (ogImage) {
      updateMetaTag('twitter:image', ogImage);
    }

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.href);

  }, [title, description, keywords, ogImage, ogType]);

  return null;
};

export default SEO;
